// player-web fetch wrapper. Bearer token stored under `player:token`.
//
// Mirrors manager-web/src/api.js — same shape, different storage key, so the
// two apps never trample each other if a manager opens the player URL on the
// same browser to debug.
//
// In dev, calls go to relative URLs (vite proxy → 127.0.0.1:5050).
// In production, set VITE_API_BASE at build time (e.g. https://api.opsora.us).

const TOKEN_KEY = 'player:token';
const API_BASE = (import.meta.env?.VITE_API_BASE || '').replace(/\/$/, '');

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || null;
}
export function setToken(value) {
  if (value) localStorage.setItem(TOKEN_KEY, value);
  else localStorage.removeItem(TOKEN_KEY);
}

export class ApiError extends Error {
  constructor(message, { status, body } = {}) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

export async function api(method, path, body, { signal } = {}) {
  const headers = { Accept: 'application/json' };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body !== undefined) headers['Content-Type'] = 'application/json';

  const url = API_BASE ? `${API_BASE}${path}` : path;
  const res = await fetch(url, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
    signal,
  });

  const text = await res.text();
  let parsed = null;
  if (text) {
    try { parsed = JSON.parse(text); } catch { parsed = { _raw: text }; }
  }

  if (!res.ok) {
    // 401 means the device token was revoked or the screen was deleted —
    // drop it and force the player back to the pairing screen.
    if (res.status === 401) setToken(null);
    const msg = parsed?.error || `${method} ${path} → ${res.status}`;
    throw new ApiError(msg, { status: res.status, body: parsed });
  }
  return parsed;
}

export const apiGet  = (p, opts)    => api('GET',  p, undefined, opts);
export const apiPost = (p, b, opts) => api('POST', p, b ?? {},   opts);
